module.exports = __webpack_public_path__ + "img/school_1.4e7b3f2.jpg";